import {invalidateSessionState} from "@/src/modules/auth/lib/invalidate-session-state";
import {useSessionEndStore} from "@/src/modules/auth/store/session-end";

type EndLocalSessionArgs = {
  reason?: string | null;
  source: "websocket" | "http" | "shift_end" | "voluntary";
};

export function endLocalSession({reason, source}: EndLocalSessionArgs): void {
  const store = useSessionEndStore.getState();

  if (store.sessionEnding) {
    return;
  }

  void source;

  store.setSessionEnding(true);
  invalidateSessionState();
  store.setEndedReason(reason ?? "unknown");
}
